/**
 * Floating chat button component (shown when chat is closed).
 */

import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

export interface ChatButtonProps {
  onClick: () => void;
}

export const ChatButton: React.FC<ChatButtonProps> = ({ onClick }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1000,
      }}
    >
      <IconButton
        onClick={onClick}
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          width: 56,
          height: 56,
          boxShadow: 3,
          '&:hover': {
            bgcolor: 'primary.dark',
          },
        }}
        aria-label="Open chat"
      >
        <ChatIcon />
      </IconButton>
    </Box>
  );
};

